import { render } from "./Empresa.vue?vue&type=template&id=190ef5c4&scoped=true"
import script from "./Empresa.vue?vue&type=script&lang=js"
export * from "./Empresa.vue?vue&type=script&lang=js"

import "./Empresa.vue?vue&type=style&index=0&id=190ef5c4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anderson\\Documents\\GitHub\\px40-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-190ef5c4"]])

export default __exports__